/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function FeatureFlagsLaunchDarkly({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M8.115 16a.314.314 0 0 1-.308-.334.294.294 0 0 1 .06-.153l3.273-4.529-5.734 2.357a.297.297 0 0 1-.306-.036.311.311 0 0 1-.11-.16.3.3 0 0 1 .13-.338l5.038-2.99-8.874-.513A.303.303 0 0 1 1 8.999a.306.306 0 0 1 .284-.305l8.88-.513-5.043-2.99a.297.297 0 0 1-.126-.338.309.309 0 0 1 .293-.222c.042 0 .084.01.123.026l5.73 2.358L7.87 2.487a.298.298 0 0 1-.029-.314A.315.315 0 0 1 8.117 2a.296.296 0 0 1 .213.092l6.524 6.555a.5.5 0 0 1 0 .703l-6.527 6.558a.298.298 0 0 1-.212.092Z" /></svg>;
}
;